//@flow
import React from 'react';
import TopLineScale from './TopLineScale/TopLineScale';
import LinePercentScale from './LinePercentScale/LinePercentScale';
import StackedBar from './StackedBar/StackedBar';
import s from './StackedBarChart.less';
import {getSummaryCost} from './StackedBarChartHelpers';
import {percentOfTotal} from '../../helpers';
import StackedBarWaterfall from './StackedBarWaterfall/StackedBarWaterfall';

type Props = {
  summaryData: Object,
  totalFob: number,
  totalFobWithTooling: number,
};

const StackedBarChart = (props: Props) => {
  const summaryData = props.summaryData;
  //TODO: not using raw fob tooling, because there are issues with it matching the total.
  const totalFobTooling = [
    'Material Cost',
    'Labor Cost',
    'Overhead Cost',
    'Profit Cost',
    'Other Cost',
    'Tooling Cost',
  ].reduce (
    (sum, section) => summaryData[section].sectionSummary.cost + sum,
    0
  );
  const totalFobwithoutTooling =
    totalFobTooling - summaryData['Tooling Cost'].sectionSummary.cost;

  const rawOtherCost = getSummaryCost ('Other Cost', summaryData);
  const displayCurrencyOtherAdjCost = rawOtherCost < 0 ? '-$' : '$';
  const displayOtherAdjCost = rawOtherCost < 0
    ? `${displayCurrencyOtherAdjCost}${rawOtherCost * -1}`
    : `${displayCurrencyOtherAdjCost}${rawOtherCost}`;

  return (
    <div>
      <div className={`row`}>
        <TopLineScale
          totalFobTooling={totalFobTooling}
          totalFobwithoutTooling={totalFobwithoutTooling}
          data={summaryData}
        />
        {summaryData['Other Cost'].sectionSummary.cost >= 0
          ? <StackedBar
              totalFobTooling={totalFobTooling}
              data={summaryData}
              totalFobwithoutTooling={totalFobwithoutTooling}
              otherAdjustmentCost={
                summaryData['Other Cost'].sectionSummary.cost
              }
            />
          : <StackedBarWaterfall
              totalFobTooling={totalFobTooling}
              totalFobwithoutTooling={totalFobwithoutTooling}
              summaryData={summaryData}
              otherAdjustmentCost={
                summaryData['Other Cost'].sectionSummary.cost
              }
            />}
        <LinePercentScale
          data={summaryData}
          totalFobTooling={totalFobTooling}
        />
      </div>
      <div className={`row`}>
        <ul className={`${s.legend}`}>
          <li>
            Material Cost
            {' '}
            ($<span data-e2e="Material-Cost-Bar">
              {getSummaryCost ('Material Cost', summaryData)}
            </span>
            {', '}
            {percentOfTotal (
              totalFobwithoutTooling,
              summaryData['Material Cost'].sectionSummary.cost
            )}
            )
          </li>
          <li>
            Labor Cost
            {' '}
            ($<span data-e2e="Labor-Cost-Bar">
              {getSummaryCost ('Labor Cost', summaryData)}
            </span>
            {', '}
            {percentOfTotal (
              totalFobwithoutTooling,
              summaryData['Labor Cost'].sectionSummary.cost
            )}
            )
          </li>
          <li>
            Overhead Cost
            {' '}
            ($<span data-e2e="Overhead-Cost-Bar">
              {getSummaryCost ('Overhead Cost', summaryData)}
            </span>
            {', '}
            {percentOfTotal (
              totalFobwithoutTooling,
              summaryData['Overhead Cost'].sectionSummary.cost
            )}
            )
          </li>
          <li>
            Profit Cost
            {' '}
            ($<span data-e2e="Profit-Cost-Bar">
              {getSummaryCost ('Profit Cost', summaryData)}
            </span>
            {', '}
            {percentOfTotal (
              totalFobwithoutTooling,
              summaryData['Profit Cost'].sectionSummary.cost
            )}
            )
          </li>
          <li>
            Other Cost
            {' '}
            ({displayOtherAdjCost}
            {', '}
            {percentOfTotal (
              totalFobwithoutTooling,
              summaryData['Other Cost'].sectionSummary.cost
            )}
            )
            <span className={`${s.hiddenElement}`}>{rawOtherCost}</span>
          </li>
          <li>
            Tooling Cost
            {' '}
            ($<span data-e2e="Tooling-Cost-Bar">
              {getSummaryCost ('Tooling Cost', summaryData)}
            </span>
            {', '}
            {percentOfTotal (
              totalFobwithoutTooling,
              summaryData['Tooling Cost'].sectionSummary.cost
            )}
            )
          </li>
        </ul>
      </div>
    </div>
  );
};

export default StackedBarChart;



// WEBPACK FOOTER //
// ./src/components/StackedBarChart/StackedBarChart.js